import axios from "axios";

/**
 * Inscribe a un estudiante en una practica.
 * @param {string} userId ID del estudiante.
 * @param {string} practiceId ID de la practica.
 * @return {Object} Respuesta.
 */
export async function enrollToPractice(practiceId, courseId) {
  return axios
    .post(`${import.meta.env.VITE_API_BASE_URL}/api/practices/enroll`, {practice: practiceId, moduleId: courseId})
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getStudentStatusPractice(courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/practices/getStudentStatus`, {
      params: { moduleId: courseId}
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}


export async function getPractice(practiceId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/practices/${practiceId}`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getExercises(practiceId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/practices/${practiceId}/exercises`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
